import React, {useEffect, useState} from "react";
import Header from "../components/Header";
import s from "../assets/css/Contact.module.css";
import {useSeo} from "../hooks/useMetadata";
import GoftinoWidget from "../components/GoftinoWidget";

export default function Contact() {
    const [form, setForm] = useState({name: "", email: "", message: ""});
    const [sent, setSent] = useState(false);

    const handleChange = (e) => setForm({...form, [e.target.name]: e.target.value});

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!form.name || !form.email || !form.message) return;
        setSent(true);
        setForm({name: "", email: "", message: ""});
    };

    useEffect(() => {
        if (sent) {
            const t = setTimeout(() => setSent(false), 3000);
            return () => clearTimeout(t);
        }
    }, [sent]);

    useSeo('استودیو بازیسازی مدریک: ارتباط با ما', 'به استودیوی بازیسازی مدریک خوش آمدید. نظرات خود را با ما به اشتراک بگذارید', {keywords: 'medrick, game studio, mobile game'});

    return (<>
        <Header title=" بی‌خیالش ! بازی کن"/>
        <GoftinoWidget />
        <section dir="rtl" className={s.root}>
            <div className={s.wrap}>
                <div className={s.card}>
                    <div className={s.info}>
                        <h1 className={s.title}>تماس با ما</h1>
                        <p className={s.desc}>
                            برای ارتباط با تیم <b>مدریک</b>، لطفاً فرم زیر را پر کنید.
                            ما در سریع‌ترین زمان پاسخ‌گوی شما خواهیم بود.
                        </p>
                        <div className={s.details}>
                            <p>📧 <span>info@medrickian.com</span></p>
                            <p>📍
                                <span>تهران، خیابان شهید بهشتی، خیابان پاکستان، خیابان مزارشریف، پلاک ۱۰</span>
                            </p>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit} className={s.form}>
                        <label>
                            نام شما
                            <input
                                type="text"
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                placeholder="لطفا نام خود را وارد نمایید..."
                                required
                            />
                        </label>

                        <label>
                            ایمیل
                            <input
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                placeholder="example@mail.com"
                                required
                            />
                        </label>

                        <label>
                            پیام شما
                            <textarea
                                name="message"
                                value={form.message}
                                onChange={handleChange}
                                placeholder="متن پیام خود را بنویسید..."
                                rows="4"
                                required
                            />
                        </label>

                        <button type="submit">ارسال پیام</button>
                    </form>
                </div>
            </div>

            {sent && <div className={s.toast}>✅ پیام شما ارسال شد</div>}
        </section>
    </>);
}
